var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHalfEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 400,
    viewBox: "0 0 94 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: -106.631,
    cy: 200,
    r: 200,
    fill: "#F9C626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfEllipse);
export default __webpack_public_path__ + "static/media/half_ellipse.d4be25be8e63ae3b0bb1a02c91df03b9.svg";
export { ForwardRef as ReactComponent };